import { getVueTemplate } from "../../_imports/utils/utils.common";
import validateBusinessEmail from "../../../components/forms/utils/validateBusinessEmail";
import FormsBaseInputField from "./_imports/forms-base-input-field.vue";

export default {
	name: 'forms-email-field',
	template: getVueTemplate('forms-email-field'),
	mixins: [
		FormsBaseInputField
	],
    data() {
        return {
            doneTypingTimeout: 500,
            knownEmail: false,
            userInput: '',
            verifyingEmail: false
        };
    },
    created() {
        this.addValidations();
    },
    watch: {
        formState() {
            this.verifyingEmail = this.formState.formVerifyingEmail;
            this.knownEmail = this.formState.formEmailIsKnown;
        },
        userInput() {
            this.knownEmail = false;
        }
    },
    methods: {
        addValidations() {
            this.addFieldValidation(validation => {
                let isValid = true;
    
                const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                isValid = emailRegex.test(String(this.userInput).toLowerCase());
    
                if (isValid) {
                    if (this.isEmailInDeniedDomains()) {
                        return validation.hasFailed(this.getFieldErrorMessage('invalidEmailDomainError'))
                    }

                    if (this.field.businessEmailsOnly
                        && !validateBusinessEmail(this.userInput)) {
                        return validation.hasFailed(this.getFieldErrorMessage('invalidBusinessEmailError'))
                    }
                } else {
                    return validation.hasFailed(this.getFieldErrorMessage('invalidEmailError'));
                }

                return validation.hasPassed();
            });
        },
        shouldDisplayWelcomeBack() {
            return this.knownEmail && !this.formState.formVerifyingEmail;
        },
        isEmailInDeniedDomains() {
            const domain = this.userInput.split('@')[1];

            if (!domain) {
                return false;
            }

            return CoveoWebsite?.forms?.deniedDomains?.includes(domain);
        }
    }
};